import api from '../index'
import urls from './url'
import appHelper from '@/utils/AppHelper'

export default {
  /**
   * post带上token
   * @param {*} url
   * @param {*} params
   */
  post(url, params) {
    var tokenInfo = appHelper.getUserTokenInfo();
    var headers = {
      'Content-Type': 'application/x-www-form-urlencoded',
      'token': tokenInfo.Token
    }
    return api.post(url, params, headers)
  },
  /**
   * 切换公司
   * @param {*} params
   */
  toggleCompany(params) {
    return this.post(urls.toggleCompany, params)
  },
  /**
   * 获取摄像机
   * @param {*} params
   */
  queryCamDevList(params) {
    return this.post(urls.queryCamDevList, params)
  },
  /**
   * 获取摄像机
   * @param {*} params
   */
  queryCamDevAllList(params) {
    return this.post(urls.queryCamDevAllList, params)
  },
  /**
  * 查询历史记录
  * @param {*} params
  */
  queryCamImageList(params) {
    return this.post(urls.queryCamImageList, params)
  },
  /**
  * 获取今天的历史记录
  * @param {*} params
  */
  getCamImageByCurDate(params) {
    return this.post(urls.getCamImageByCurDate, params)
  },
  /**
  * 获取刷新的历史记录
  * @param {*} params
  */
  getRefreshCamImage(params) {
    return this.post(urls.getRefreshCamImage, params)
  },
  /**
  * 获取历史记录详情
  * @param {*} params
  */
  getCamImageDetail(params) {
    return this.post(urls.getCamImageDetail, params)
  },
  /**
  * 统计历史记录数量
  * @param {*} params
  */
  statCamImageCount(params) {
    return this.post(urls.statCamImageCount, params)
  },
  /**
   * 生成用户邀请码
   * @param {*} params
   */
  createUserInvite(params) {
    return this.post(urls.createUserInvite, params)
  },
  /**
   * 获取用户邀请内容
   * @param {*} params
   */
  getUserInvite(params) {
    return this.post(urls.getUserInvite, params)
  },
  /**
   * 微信用户加入PC账户
   * @param {*} params
   */
  joinUser(params) {
    return this.post(urls.joinUser, params)
  },
  /**
  * 获取微信用户已加入的用户列表
  * @param {*} params
  */
  getUserStaffList(params) {
    return this.post(urls.getUserStaffList, params)
  },
  /**
  * 切换用户
  * @param {*} params
  */
  toggleUser(params) {
    return this.post(urls.toggleUser, params)
  },
  /**
  * 统计历史数量
  * @param {*} params
  */
  statTotalByTimeSpan(params) {
    return this.post(urls.statTotalByTimeSpan, params)
  },
  /**
  * 最近7天每天历史统计
  * @param {*} params
  */
  stat7DayCamImage(params) {
    return this.post(urls.stat7DayCamImage, params)
  },
  /**
  * 获取历史记录详情(区间测速)
  * @param {*} params
  */
  getCarSpeedABDetail(params) {
    return this.post(urls.getCarSpeedABDetail, params)
  }


}
